import React from 'react';
import PropTypes from 'prop-types';

import {
  StyledLabel,
  StyledBoxInputInterest,
  StyledBoxModule,
  StyledOrderItem,
  StyledIcon
} from './style';

import Input from '../../../core/Input';
import { INTERESTS } from '../../../../constants/literals/modals';
import { Trash } from '../../../../../assets/images/index';

const InterestItem = ({
  interest,
  onChangeInput,
  onClickDelete,
  onClickDown,
  onClickUp,
  order
}) => (
  <StyledBoxModule>
    <StyledOrderItem
      order={order}
      onClickDown={onClickDown}
      onClickUp={onClickUp}
    />

    <StyledBoxInputInterest>
      <StyledLabel>{INTERESTS.INTEREST}</StyledLabel>
      <Input onChange={onChangeInput} value={interest} />
    </StyledBoxInputInterest>
    <StyledIcon svg={Trash} onClick={onClickDelete} hover />
  </StyledBoxModule>
);

InterestItem.propTypes = {
  interest: PropTypes.string,
  onChangeInput: PropTypes.func,
  onClickDelete: PropTypes.func,
  onClickDown: PropTypes.func,
  onClickUp: PropTypes.func,
  order: PropTypes.number
};

InterestItem.defaultProps = {
  interest: '',
  order: 0
};

export default InterestItem;
